/* ============================================================
   MyPokea — home page JS
   - generation grid
   - best-sellers / nouveautés grids
   ============================================================ */

function _altStd(name, num) {
  const parts = ['Finger puppet', 'Figurine Pokémon', 'Pokémon Kids', name || ''];
  if (num != null) parts.push('N°' + String(num).padStart(3, '0'));
  return parts.join(' | ');
}

/* Vraie photo produit du site, jamais un sprite officiel. */
const GENERIC_REAL_FALLBACK_IMG = "https://cdn.shopify.com/s/files/1/0972/9173/1277/files/Pokemon-Bulbizarre-Bulbasaur-Bisasam-001-figurine-finger-puppet-v4.webp?v=1782133857";

document.addEventListener("DOMContentLoaded", () => {
  renderGenerations();
  fetchHomeStarterImages();
  renderSpecials();
  renderBoitesHome();
  renderBestsellers();
  renderNew();
});
window.onLangChange = () => {
  renderGenerations();
  renderSpecials();
};

function renderGenerations() {
  const root = document.getElementById("gen-grid");
  if (!root) return;
  const GEN_STARTERS = {
    1:[1,4,7], 2:[152,155,158], 3:[252,255,258], 4:[387,390,393],
    5:[495,498,501], 6:[650,653,656], 7:[722,725,728], 8:[810,813,816], 9:[906,909,912],
  };
  const allPokes = [...POKE.GEN1, ...POKE.GEN2, ...(POKE.GEN3 || [])];
  const starterMedallion = (id) => {
    const po = allPokes.find(p => p.id === id);
    return `<div class="gen-starter-tile" data-starter="${id}">
      <img src="${GENERIC_REAL_FALLBACK_IMG}" alt="${_altStd(po ? po.name : '', id)}" loading="lazy">
      <div class="st-name">${po ? po.name : ''}</div>
      <div class="st-price" data-starter-price="${id}"></div>
    </div>`;
  };
  const starterDisc = (id, idx) =>
    `<div class="gen-card-starter-disc" style="z-index:${3-idx};"><img src="${GENERIC_REAL_FALLBACK_IMG}" data-starter="${id}" alt="" loading="lazy"></div>`;
  var GEN_PAGE_HANDLE = { 1: 'pokedex-kanto', 2: 'pokedex-johto', 3: 'pokedex-hoenn', 4: 'pokedex-sinnoh', 5: 'pokedex-unys', 6: 'pokedex-kalos', 7: 'pokedex-alola', 8: 'pokedex-galar', 9: 'pokedex-paldea' };
  const genPageUrl = (gen) => GEN_PAGE_HANDLE[gen] ? '/pages/' + GEN_PAGE_HANDLE[gen] : '/pages/pokedex?gen=' + gen;
  const items = POKE.GENERATIONS.map((g) => {
    const starters = GEN_STARTERS[g.gen] || [];
    const isFeature = g.gen === 1;
    if (isFeature) {
      return `
        <a class="gen-card feature" style="--gen-color: ${g.color}; --gen-deep: ${g.deep || g.color};" href="${genPageUrl(g.gen)}">
          <span class="gen-card-num">GEN ${String(g.gen).padStart(2,'0')} · ${g.years}</span>
          <h3 class="gen-card-name">${g.name}<span class="gen-card-kanji-sm">${g.kanji}</span></h3>
          <div class="gen-card-meta">${g.count} Pokémon</div>
          <p class="gen-card-blurb">${g.blurb}</p>
          <div class="gen-starter-trio">${starters.map(starterMedallion).join("")}</div>
          <div class="gen-card-stock">
            <div class="gen-card-bar"><div style="width:${g.stockPct}%;"></div></div>
            <span class="gen-card-stock-lbl">${g.stockPct}${t('gen.stock')}</span>
          </div>
          <span class="gen-card-cta">
            ${t('gen.explore')}
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>
          </span>
        </a>
      `;
    }
    return `
      <a class="gen-card ${g.upcoming ? 'upcoming' : ''}" style="--gen-color: ${g.color}; --gen-deep: ${g.deep || g.color};"
         href="${g.upcoming ? '#' : genPageUrl(g.gen)}">
        ${g.upcoming ? `<span class="upcoming-badge">${t('gen.soon')}</span>` : ''}
        <div class="gen-card-head">
          <div>
            <span class="gen-card-num">GEN ${String(g.gen).padStart(2,'0')}</span>
            <h3 class="gen-card-name">${g.name}</h3>
          </div>
          ${g.upcoming ? '' : `<div class="gen-card-starters">${starters.map(starterDisc).join("")}</div>`}
        </div>
        <div class="gen-card-meta">${g.count || '—'} Pokémon</div>
        ${g.upcoming
          ? `<div class="gen-card-stock"><span class="gen-card-stock-lbl">${t('gen.soon')}</span></div>`
          : `<div class="gen-card-stock">
               <div class="gen-card-bar"><div style="width:${g.stockPct}%;"></div></div>
               <span class="gen-card-stock-lbl">${g.stockPct}${t('gen.stock')}</span>
             </div>`}
      </a>
    `;
  });
  root.innerHTML = items.join("");
}

function fetchHomeStarterImages() {
  const HOME_STARTERS = {
    1: { 1: 'bulbizarre', 4: 'salameche', 7: 'carapuce' },
    2: { 152: 'germignon', 155: 'hericendre', 158: 'totodile' },
  };
  const norm = s => s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  const isSpecial = t => /mega|gigamax|alola|galar|hisui|paldea|armure/i.test(t);

  [['kanto', 1], ['johto', 2]].forEach(([col, gen]) => {
    fetch(`/collections/${col}/products.json?limit=250&sort_by=title`)
      .then(r => r.ok ? r.json() : null)
      .then(data => {
        if (!data || !data.products) return;
        Object.entries(HOME_STARTERS[gen] || {}).forEach(([id, name]) => {
          const idNum = parseInt(id);
          const nameKey = norm(name);
          const match = data.products.find(p => {
            if (isSpecial(p.title)) return false;
            return norm(p.title).includes(nameKey);
          });
          if (!match) return;
          const prodImg   = match.images && match.images[0] ? match.images[0].src : null;
          const prodPrice = match.variants && match.variants[0] ? parseFloat(match.variants[0].price) : null;
          const prodUrl   = `/products/${match.handle}`;
          document.querySelectorAll(`[data-starter="${idNum}"]`).forEach(el => {
            if (el.tagName === 'IMG') {
              if (prodImg) el.src = prodImg;
            } else {
              const imgEl = el.querySelector('img');
              if (imgEl && prodImg) imgEl.src = prodImg;
              if (prodUrl) {
                el.style.cursor = 'pointer';
                el.onclick = (e) => { e.stopPropagation(); location.href = prodUrl; };
              }
              const priceEl = el.querySelector(`[data-starter-price="${idNum}"]`);
              if (priceEl && prodPrice) priceEl.textContent = prodPrice.toFixed(2).replace('.', ',') + ' €';
            }
          });
        });
      });
  });
}

function fmtPrice(p) {
  return p.toFixed(2).replace('.', ',') + ' €';
}

function renderBoitesHome() {
  const root = document.getElementById("boites-home-grid");
  if (!root) return;
  const feat = POKE.GENERATIONS.filter(g => !g.upcoming).slice(0, 4);
  root.innerHTML = feat.map(g => {
    const boxPrice = Math.round((g.count * 7.4) / 10) * 10 + 9.90;
    return `
      <a class="boite-home-card" href="/pages/boites" style="--gc:${g.color};">
        <div class="boite-home-media" style="--gc:${g.color};">
          <image-slot id="boite-home-${g.gen}" shape="rect" placeholder="Coffret ${g.name} scellé"></image-slot>
          <span class="boite-home-seal">Scellé · 未開封</span>
          <span class="boite-home-kanji" aria-hidden="true">${g.kanji}</span>
        </div>
        <div class="boite-home-info">
          <div class="boite-home-region">GEN ${String(g.gen).padStart(2,'0')} · ${g.name}</div>
          <div class="boite-home-name">Coffret ${g.name}</div>
          <div class="boite-home-row">
            <span>${g.count} figurines</span>
            <strong>${fmtPrice(boxPrice)}</strong>
          </div>
        </div>
      </a>
    `;
  }).join("");
}

function renderSpecials() {
  const root = document.getElementById("special-grid");
  if (!root) return;
  root.innerHTML = POKE.SPECIALS.map((c, idx) => {
    const isFeature = idx === 0;
    const thumbs = isFeature
      ? `<div class="special-thumbs">${[0,1,2,3,4].map(i =>
          `<image-slot id="special-shiny-${i}" class="special-thumb-slot" shape="rounded" placeholder="Shiny ${i+1}"></image-slot>`).join("")}</div>`
      : "";
    return `
      <a class="special-card ${isFeature ? 'feature' : ''}" href="/pages/speciales?cat=${c.id}"
         style="--sp-color: ${c.color}; --sp-color-deep: ${c.accentDeep};">
        ${isFeature ? `<span class="special-badge">${t('spec.rare')}</span>` : ''}
        <span class="special-kanji" aria-hidden="true">${c.kanji}</span>
        <span class="special-tagline">${c.tagline}</span>
        <h3 class="special-name">${c.name}</h3>
        <div class="special-meta">
          <span>${c.count} ${t('spec.pieces')}</span>
          <span>${c.years}</span>
        </div>
        ${isFeature ? `<p class="special-blurb">${c.blurb}</p>` : ''}
        ${thumbs}
        ${!isFeature ? `<div class="special-pricefrom">${t('spec.from')} ${fmtPrice(c.priceFrom)}</div>` : ''}
        <span class="special-cta">
          ${isFeature ? t('spec.exploreShiny') : t('spec.discover')}
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>
        </span>
      </a>
    `;
  }).join("");
}

function productCard({ id, name, meta, badges, price, oldPrice, bg, slotId, placeholder }) {
  const badgePills = (badges || []).map(b => `<span class="pill ${b.cls} pill-sm">${b.label}</span>`).join("");
  return `
    <div class="product-card">
      <div class="product-media" style="background:${bg};">
        <image-slot id="${slotId}" shape="rect" placeholder="${placeholder}"></image-slot>
        <div class="product-badges">${badgePills}</div>
        <button class="product-fav" aria-label="Favori" data-fav>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1A5.5 5.5 0 0 0 3.1 12.5l8 8a1 1 0 0 0 1.4 0l8.3-8.2a5.5 5.5 0 0 0 0-7.8Z"/></svg>
        </button>
      </div>
      <div class="product-info">
        <div class="product-meta">${meta}</div>
        <div class="product-name">${name}</div>
        <div class="product-row">
          <div class="product-price">
            <strong>${fmtPrice(price)}</strong>
            ${oldPrice ? `<span class="old">${fmtPrice(oldPrice)}</span>` : ''}
          </div>
          <button class="product-add" data-add='${JSON.stringify({ id, name, meta, price, bg }).replace(/'/g, "&#39;")}' aria-label="Ajouter au panier">+</button>
        </div>
      </div>
    </div>
  `;
}

const BESTSELLERS = [
  { id: 25, slotName: "home-best-25", name: "Pikachu",   meta: "Figurine Kids · Bandai",     price: 9.90,  oldPrice: 12.90, bg: "var(--yellow)", badges: [{label:"Bestseller", cls:"pill-solid"}, {label:"-23%", cls:"pill-red"}] },
  { id: 6,  slotName: "home-best-6",  name: "Dracaufeu", meta: "Peluche Pokémon Center 30cm", price: 49.00, bg: "var(--red)",    badges: [{label:"Pokémon Center", cls:"pill-blue"}] },
  { id: 133, slotName: "home-best-133", name: "Évoli",     meta: "Peluche Pokémon Center 20cm", price: 32.50, bg: "var(--orange)", badges: [{label:"Bestseller", cls:"pill-solid"}] },
  { id: 94, slotName: "home-best-94", name: "Ectoplasma",meta: "Figurine Kids · Bandai",     price: 12.50, oldPrice: 15.90, bg: "var(--lilac)",  badges: [{label:"Rare", cls:"pill-pink"}, {label:"-22%", cls:"pill-red"}] },
];

const NEW_ARRIVALS = [
  { id: 7,   slotName: "home-new-7",   name: "Carapuce", meta: "Figurine Kids · Bandai 2023", price: 8.90,  bg: "var(--blue)",   badges: [{label:"Nouveau", cls:"pill-green"}] },
  { id: 1,   slotName: "home-new-1",   name: "Bulbizarre", meta: "Peluche Pokémon Center 20cm", price: 28.90, bg: "var(--green)",  badges: [{label:"Nouveau", cls:"pill-green"}] },
  { id: 65,  slotName: "home-new-65",  name: "Alakazam",  meta: "Figurine Kids · Bandai",     price: 11.50, bg: "var(--pink)",   badges: [{label:"Nouveau", cls:"pill-green"}, {label:"Rare", cls:"pill-lilac"}] },
  { id: 143, slotName: "home-new-143", name: "Ronflex",   meta: "Peluche Pokémon Center 30cm", price: 54.00, bg: "var(--cream-2)", badges: [{label:"Nouveau", cls:"pill-green"}] },
];

function renderBestsellers() {
  const root = document.getElementById("bestsellers-grid");
  if (!root) return;
  root.innerHTML = BESTSELLERS.map(p => productCard({
    id: `${p.id}-kids`,
    name: p.name,
    meta: p.meta,
    badges: p.badges,
    price: p.price,
    oldPrice: p.oldPrice,
    bg: p.bg,
    slotId: p.slotName,
    placeholder: p.name,
  })).join("");
  bindCardActions(root, BESTSELLERS);
}

function renderNew() {
  const root = document.getElementById("new-grid");
  if (!root) return;
  root.innerHTML = NEW_ARRIVALS.map(p => productCard({
    id: `${p.id}-kids-new`,
    name: p.name,
    meta: p.meta,
    badges: p.badges,
    price: p.price,
    bg: p.bg,
    slotId: p.slotName,
    placeholder: p.name,
  })).join("");
  bindCardActions(root, NEW_ARRIVALS);
}

function bindCardActions(root, source) {
  root.querySelectorAll("[data-add]").forEach(b => {
    b.onclick = (e) => {
      e.preventDefault();
      const item = JSON.parse(b.dataset.add.replace(/&#39;/g, "'"));
      Cart.add({
        id: item.id,
        name: item.name,
        price: item.price,
        variant: item.meta,
        bg: item.bg,
        qty: 1,
      });
      // visual feedback
      b.textContent = "✓";
      setTimeout(() => { b.textContent = "+"; }, 900);
    };
  });
  root.querySelectorAll("[data-fav]").forEach(b => {
    b.onclick = () => b.classList.toggle("on");
  });
}
